import {makeAutoObservable} from "mobx";
import CatalogService from "../service/catalogService";
export default class OrderStore{
    constructor() {
        this._catalogs = []
        this._subCatalogs = []
        this._loading = false
        makeAutoObservable(this)
    }

    async getAll(selectDate){
        try{
            this._loading = true
            const fetch = await CatalogService.getAll(selectDate);
            this._catalogs = fetch
            this._loading = false
            return fetch
        }catch (e) {
            this._loading = false
        }
    }

    async getAllSub(){
        try{
            this._loading = true
            const fetch = await CatalogService.getAllSub();
            this._subCatalogs = fetch
            this._loading = false
            return fetch
        }catch (e) {
            this._loading = false
        }
    }
}



